import React, { useContext } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import Box from '../../../../components/elements/Box';
import Text from '../../../../components/elements/Text';
import { fullMonths } from '../../../../helpers/localization/localizationUtils';
import dayjs from 'dayjs';

type MonthCaptionProps = {
  date: Date;
  style?: React.CSSProperties;
  showYear?: boolean;
  monthSettings?: $TSFixMe;
  yearSettings?: $TSFixMe;
};

function MonthCaption(props: MonthCaptionProps) {
  const { date, showYear } = props;
  const { direction, theme, translate, localizationData } = useContext(Context);
  const [className, style] = useStyles(
    {
      paddingBottom: '20px',
      display: 'flex',
      justifyContent: 'center',
      ...props
    },
    { direction, theme }
  );
  const dtpClassName = `${className} front10-date-selector-caption`;
  const monthsLabels = fullMonths(translate, localizationData);

  return (
    <Box {...props} className={dtpClassName} style={style} data-testid="calendar-month-caption">
      <Text className="front10-date-selector-caption-month" {...props.monthSettings}>
        {monthsLabels[date.getMonth()]}
      </Text>
      {showYear && (
        <Text className="front10-date-selector-caption-year" {...props.yearSettings}>
          {dayjs(date).format('YYYY')}
        </Text>
      )}
    </Box>
  );
}

MonthCaption.defaultProps = {
  fontSize: '4',
  textAlign: 'center',
  monthSettings: {
    marginRight: '2'
  }
};
export default MonthCaption;
